// The Firebase SDK (~400 KB) is loaded on first use: only the order list and the tablet pages read the
// tablet status from it (tasks#158), so it stays out of the entry bundle.
const firebaseConfig = {
    apiKey: 'AIzaSyBeoillAiWXoya02Uji6P8aFu-Jh5PbShw',
    authDomain: 'halogen-emblem-191119.firebaseapp.com',
    projectId: 'halogen-emblem-191119',
    storageBucket: 'halogen-emblem-191119.appspot.com',
    databaseURL:
        'https://halogen-emblem-191119-default-rtdb.europe-west1.firebasedatabase.app',
    messagingSenderId: '153218582821',
    appId: '1:153218582821:web:4c66e3b544d7beebf572cc',
    measurementId: 'G-9QTH7ENQLY',
}

let appPromise = null

export const firebaseApp = () => {
    if (!appPromise) {
        appPromise = Promise.all([
            import(/* webpackChunkName: "firebase" */ 'firebase/app'),
            import(/* webpackChunkName: "firebase" */ 'firebase/auth'),
            import(/* webpackChunkName: "firebase" */ 'firebase/database'),
        ]).then(([{ default: firebase }]) =>
            firebase.initializeApp(firebaseConfig)
        )
        appPromise.catch((e) => {
            appPromise = null
            // eslint-disable-next-line no-console
            console.log(`Firebase error: ${e}`)
        })
    }
    return appPromise
}

export const firebaseDb = async () => (await firebaseApp()).database()

export const firebaseAuth = async () => (await firebaseApp()).auth()
